import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dogProfile: null,
};

const manageDogsSlice = createSlice({
  name: "manageDogs",
  initialState,
  reducers: {
    setDogProfile: (state, action) => {
      state.dogProfile = action.payload;
    },
  },
});

export const { setDogProfile } = manageDogsSlice.actions;

export default manageDogsSlice.reducer;
